import { AppGlobals } from "app/app.globals";

export class Prestation {
  constructor(
    public Cle: number,
    public ClePeriodeOccupation: number,
    public CleCodePrestation: number,
    public CodePrestationCode: string,
    public Date: Date,
    public Debut: string,
    public DureeQte: string,
    public Repos: string,
    public Quantite: number,
    public MontantPaie: number,
    public TypeHeureJour: number,
    public Signe: number,
    public MemoRemarque: string,
    public CodePrestationEncodageHeure: number,
    public CodePrestationCleUnite: number) {
      if (MemoRemarque != null)
        this.MemoRemarque = AppGlobals.base64decode(MemoRemarque);
    }
}
